export const CONTROL_INFO_FETCHING = 'CONTROL_INFO_FETCHING';
export const CONTROL_INFO_FETCHED = 'CONTROL_INFO_FETCHED';
export const CONTROL_INFO_FETCH_ERROR = 'CONTROL_INFO_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/state/controlInfo/types.js